<div class="flex items-center justify-center h-screen">
    <div class="flex flex-col ml-180 w-full items-center">
        <img
            style="height: 380px; width: 420px"
            src="assets\images\pro-pic.png"
        />
        <br />
        <label class="text 1xl sm:text-1xl font-bold">
            Hmmm... We're sorry , But you don't have permission to view this
            page.
        </label>
        <label class="text 1xl sm:text-1xl font-bold">
            Please contact your administrator
        </label>

        <br />

       

        <!-- <button mat-flat-button  >
        Back To DashBoard
      </button> -->
    </div>
</div>
